var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.starter.title')}}),_vm._v(" "+_vm._s(_vm._f("date")('2020-08-30T22:22:19.8631962'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm._f("dateTime")('2020-08-30T22:22:19.8631962'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }